import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-management app-page" }
const _hoisted_2 = { class: "tree-container" }
const _hoisted_3 = { class: "tree-toolbar" }
const _hoisted_4 = { class: "toolbar-actions" }
const _hoisted_5 = { class: "table-cell-name" }
const _hoisted_6 = { class: "cell-route" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_8 = { style: {"float":"left"} }
const _hoisted_9 = { style: {"float":"right","color":"#8492a6","font-size":"12px"} }

import { ref, reactive, onMounted, watch, computed, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Plus, Edit, Search, Delete, Refresh } from '@element-plus/icons-vue'
import { PermissionManagement } from '@/network/index'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { useRouteTitle } from '@/utils/useRouteTitle'
import { useButtonPermission } from '@/utils/buttonPermission'

type MenuType = '目录' | '页面' | '按钮'

export default /*@__PURE__*/_defineComponent({
  __name: 'caidan',
  setup(__props) {

useRouteTitle('菜单管理')
const { can, canAny } = useButtonPermission('/QuanXianGuanLi/caidan.vue')

// 表格引用
const tableRef = ref<any>(null)
const searchKey = ref('')
// 记录当前刷新上下文（0=根菜单，其他=当前父菜单ID）
const currentRefreshParentId = ref<string | number>(0)
// 强制重建树表格，清空 el-table 懒加载缓存
const tableRenderKey = ref(0)

// 表格数据
const menuTree = ref<any[]>([])
const loading = ref(false)

// 对话框
const dialogVisible = ref(false)
const dialogMode = ref<'create' | 'edit' | 'addChild'>('create')
const saving = ref(false)
const formRef = ref<any>(null)
const currentNode = ref<any>(null)

// 表单数据
const formData = reactive({
  Id: '',
  Name: '',
  Code: '',
  IconNew: '',
  Icon: '',
  Func: '',
  OrderSort: 0,
  IsButton: false,
  IsHide: false,
  IskeepAlive: false,
  Enabled: true,
  Description: '',
  Pid: '0',
  Mid: ''
})

// 接口列表
const interfaceList = ref<any[]>([])

// 加载接口列表
const loadInterfaceList = async () => {
  try {
    const res: any = await PermissionManagement.interfaceList(
      { page: 1, intPageSize: 9999 },
      []
    )
    if (res && res.status === 200 && res.success) {
      interfaceList.value = res.response?.data || []
    }
  } catch (error) {
    console.error('加载接口列表失败:', error)
  }
}

const handleInterfaceSelectVisibleChange = (visible: boolean) => {
  if (visible) {
    loadInterfaceList()
  }
}

// 对话框标题
const dialogTitle = computed(() => {
  if (dialogMode.value === 'create') return '添加根菜单'
  if (dialogMode.value === 'addChild') return '添加子菜单'
  return '编辑菜单'
})

// 菜单类型
const menuType = ref<MenuType>('目录')

// 表单规则
const formRules = computed(() => ({
  Name: [{ required: true, message: menuType.value === '按钮' ? '请输入按钮名称' : '请输入菜单名称', trigger: 'blur' }]
}))

const applyMenuTypeToForm = (val: MenuType) => {
  if (val === '目录') {
    formData.IsButton = false
    formData.Code = ''
  } else if (val === '按钮') {
    formData.IsButton = true
    formData.Code = ''
  } else {
    formData.IsButton = false
  }
}

// 根据菜单类型计算控制
watch(menuType, (val) => {
  applyMenuTypeToForm(val)
}, { immediate: true })

// 菜单路由是否禁用（目录和按钮时禁用）
const isCodeDisabled = computed(() => {
  return menuType.value === '目录' || menuType.value === '按钮'
})

// 菜单路由验证规则（页面时必填，且必须以/开头）
const codeRules = computed(() => {
  if (menuType.value !== '页面') return []
  return [
    { required: true, message: '请输入页面组件路径', trigger: 'blur' },
    { pattern: /^\//, message: '组件路径必须以 / 开头', trigger: 'blur' }
  ]
})

// 图标选项列表
const iconOptions = computed(() => ElementPlusIconsVue)

// 获取图标组件
const getIconComponent = (iconName: string) => {
  return (ElementPlusIconsVue as any)[iconName] || 'CircleCheck'
}

// 获取菜单类型文本
const getMenuTypeText = (row: any) => {
  if (row.IsButton) return '按钮'
  if (row.Code) return '页面'
  return '目录'
}

// 获取菜单类型标签样式
const getMenuTypeType = (row: any) => {
  if (row.IsButton) return 'warning'
  if (row.Code) return 'success'
  return 'primary'
}

// 规范化树节点结构
const normalizeTreeNodes = (nodes: any[]) => {
  nodes.forEach((item: any) => {
    const hasChildren =
      item.hasChildren ?? item.HasChildren ?? item.haschildren ?? false
    item.hasChildren = Boolean(hasChildren)
    if (Array.isArray(item.Children) && item.Children.length > 0) {
      item.hasChildren = true
      normalizeTreeNodes(item.Children)
    }
  })
}

// 根据ID在当前树中查找节点
const findNodeById = (nodes: any[], id: string | number): any | null => {
  const targetId = String(id)
  for (const node of nodes) {
    if (String(node.Id) === targetId) return node
    if (Array.isArray(node.Children) && node.Children.length > 0) {
      const found = findNodeById(node.Children, id)
      if (found) return found
    }
  }
  return null
}

const mergeMenuNodes = (oldNodes: any[] = [], newNodes: any[] = []) => {
  return newNodes.map((newNode: any) => {
    const oldNode = oldNodes.find((item: any) => String(item.Id) === String(newNode.Id))
    if (!oldNode) return newNode

    const oldChildren = Array.isArray(oldNode.Children) ? oldNode.Children : []
    const newChildren = Array.isArray(newNode.Children) ? newNode.Children : []
    const children = oldChildren.length > 0
      ? mergeMenuNodes(oldChildren, newChildren.length > 0 ? newChildren : oldChildren)
      : newChildren

    return {
      ...oldNode,
      ...newNode,
      hasChildren: Boolean(
        newNode.hasChildren ||
        newNode.HasChildren ||
        newNode.haschildren ||
        oldNode.hasChildren ||
        children.length > 0
      ),
      Children: children
    }
  })
}

// 合并根节点数据，尽量保留当前树里已经展开/已加载的子节点
const mergeRootNodes = (oldNodes: any[], newNodes: any[]) => mergeMenuNodes(oldNodes, newNodes)

const syncLazyChildren = (parentId: string | number, children: any[]) => {
  const table = tableRef.value
  const keyCandidates = Array.from(new Set([
    parentId,
    String(parentId),
    Number.isNaN(Number(parentId)) ? parentId : Number(parentId)
  ]))

  if (table?.updateKeyChildren) {
    keyCandidates.forEach((key) => {
      try {
        table.updateKeyChildren(key, children)
      } catch (error) {
        console.warn('同步菜单子节点失败:', key, error)
      }
    })
  }

  const states = table?.store?.states
  const lazyTreeNodeMap = states?.lazyTreeNodeMap?.value || states?.lazyTreeNodeMap
  const treeData = states?.treeData?.value || states?.treeData

  keyCandidates.forEach((key) => {
    if (lazyTreeNodeMap) {
      lazyTreeNodeMap[key as any] = children
    }
    if (treeData?.[key as any]) {
      treeData[key as any] = {
        ...treeData[key as any],
        expanded: true,
        loaded: true,
        loading: false,
        children: children.map((item: any) => item.Id)
      }
    }
  })
}

const expandMenuRow = (row: any) => {
  if (!row || !tableRef.value?.toggleRowExpansion) return
  try {
    tableRef.value.toggleRowExpansion(row, true)
  } catch (error) {
    console.warn('展开菜单节点失败:', error)
  }
}

// 查询某个父菜单ID下的子菜单列表
const queryMenuByParentId = async (parentId: string | number) => {
  const res: any = await PermissionManagement.getMenuTreeTable({
    Id: parentId,
    key: searchKey.value || undefined
  })
  if (res && res.status === 200 && res.success) {
    const data = res.response || []
    normalizeTreeNodes(data)
    return data
  }
  return []
}

// 加载根节点数据
const loadRootData = async () => {
  try {
    loading.value = true
    currentRefreshParentId.value = 0
    menuTree.value = await queryMenuByParentId(0)
  } catch (error) {
    console.error('加载数据失败:', error)
    menuTree.value = []
  } finally {
    loading.value = false
  }
}

// 懒加载子节点
const load = async (row: any, treeNode: any, resolve: (data: any[]) => void) => {
  try {
    currentRefreshParentId.value = row.Id
    const data = await queryMenuByParentId(row.Id)
    row.Children = data
    row.hasChildren = data.length > 0
    resolve(data)
  } catch (error) {
    console.error('加载子节点失败:', error)
    resolve([])
  }
}

// 监听搜索
watch(searchKey, () => {
  currentRefreshParentId.value = 0
  loadRootData()
})

// 按父菜单ID刷新数据：
// 1) 先刷新接口列表（与页面初始化一致）
// 2) 一定刷新根菜单(Id=0)
// 3) 若有父菜单上下文，再刷新该父菜单下最新子菜单
const refreshTable = async (parentId?: string | number) => {
  const targetParentId = parentId ?? currentRefreshParentId.value ?? 0
  const targetParentIdStr = String(targetParentId)

  try {
    loading.value = true
    await loadInterfaceList()

    // 先刷新根菜单数据，但保留当前树里已展开分支，避免子节点显示被重置
    const latestRootNodes = await queryMenuByParentId(0)
    const nextMenuTree = mergeRootNodes(menuTree.value, latestRootNodes)

    // 先提交根节点的新数据，再操作 el-table 的懒加载缓存；否则缓存会指向旧树分支。
    menuTree.value = [...nextMenuTree]
    await nextTick()

    // 若当前在某个父菜单上下文，再额外刷新该父菜单下子菜单并展开本次操作的父节点。
    if (targetParentIdStr !== '0') {
      const latestChildren = await queryMenuByParentId(targetParentId)
      const parentNode = findNodeById(menuTree.value, targetParentId)
      if (parentNode) {
        parentNode.Children = latestChildren
        parentNode.hasChildren = latestChildren.length > 0
        menuTree.value = [...menuTree.value]
        await nextTick()
        expandMenuRow(parentNode)
        syncLazyChildren(targetParentId, latestChildren)
        currentRefreshParentId.value = targetParentId
      } else {
        currentRefreshParentId.value = 0
      }
    } else {
      currentRefreshParentId.value = 0
    }
  } catch (error) {
    console.error('刷新数据失败:', error)
  } finally {
    loading.value = false
  }
}

// 添加根菜单
const handleAddRoot = () => {
  dialogMode.value = 'create'
  resetForm()
  menuType.value = '目录'
  applyMenuTypeToForm(menuType.value)
  currentNode.value = null
  formData.Pid = '0'
  formData.Mid = ''
  currentRefreshParentId.value = 0
  dialogVisible.value = true
}

// 添加子菜单
const handleAddChild = (data: any) => {
  dialogMode.value = 'addChild'
  resetForm()
  menuType.value = '目录'
  applyMenuTypeToForm(menuType.value)
  formData.Pid = data.Id
  formData.Mid = data.Mid || ''
  currentNode.value = data
  currentRefreshParentId.value = data.Id
  dialogVisible.value = true
}

// 删除菜单
const handleDelete = (data: any) => {
  ElMessageBox.confirm(`确定要删除菜单 "${data.Name}" 吗？`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res: any = await PermissionManagement.deleteMenu({ id: data.Id })
      if (res && res.status === 200 && res.success) {
        ElMessage.success('删除成功')
        const parentId = data?.Pid ?? 0
        await refreshTable(parentId)
      } else {
        ElMessage.error(res?.msg || '删除失败')
      }
    } catch (error) {
      console.error('删除菜单失败:', error)
      ElMessage.error('删除失败')
    }
  }).catch(() => {
    // 用户取消删除
  })
}

// 编辑菜单
const handleEdit = (data: any) => {
  dialogMode.value = 'edit'
  currentNode.value = data
  // 填充表单
  Object.assign(formData, data)
  // 根据数据推断菜单类型
  const nextMenuType: MenuType = data.IsButton
    ? '按钮'
    : data.Code
      ? '页面'
      : '目录'
  menuType.value = nextMenuType
  if (nextMenuType === '按钮') {
    menuType.value = '按钮'
    formData.IsButton = true
    formData.Code = ''
  } else if (nextMenuType === '页面') {
    formData.IsButton = false
    formData.Code = data.Code || ''
  } else {
    formData.IsButton = false
    formData.Code = ''
  }
  dialogVisible.value = true
}

// 重置表单
const resetForm = () => {
  formRef.value?.clearValidate?.()
  formData.Id = ''
  formData.Name = ''
  formData.Code = ''
  formData.IconNew = ''
  formData.Icon = ''
  formData.Func = ''
  formData.OrderSort = 0
  formData.IsButton = false
  formData.IsHide = false
  formData.IskeepAlive = false
  formData.Enabled = true
  formData.Description = ''
  formData.Pid = '0'
  formData.Mid = ''
}

// 提交表单
const handleSubmit = () => {
  formRef.value?.validate(async (valid: boolean) => {
    if (!valid) return
    try {
      saving.value = true
      applyMenuTypeToForm(menuType.value)
      const isCreate = dialogMode.value === 'create' || dialogMode.value === 'addChild'
      const res: any = isCreate
        ? await PermissionManagement.createMenu({ ...formData })
        : await PermissionManagement.updateMenu({ ...formData })
      if (res && res.status === 200 && res.success) {
        ElMessage.success(isCreate ? '创建成功' : '更新成功')
        dialogVisible.value = false
        const refreshParentId = isCreate
          ? (formData.Pid || 0)
          : (currentNode.value?.Pid ?? formData.Pid ?? 0)
        await refreshTable(refreshParentId)
      } else {
        ElMessage.error(res?.msg || (isCreate ? '创建失败' : '更新失败'))
      }
    } catch (error) {
      console.error('保存菜单失败:', error)
      ElMessage.error('保存失败')
    } finally {
      saving.value = false
    }
  })
}

// 挂载时加载数据
onMounted(() => {
  loadInterfaceList()
  loadRootData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: searchKey.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
          placeholder: "搜索菜单",
          clearable: "",
          class: "search-input",
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(can)('列表'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                icon: _unref(Refresh),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (refreshTable())),
                title: "刷新"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (_unref(can)('新增'))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                icon: _unref(Plus),
                onClick: handleAddRoot
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode(" 添加根菜单 ")
                ])),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_el_scrollbar, { class: "tree-scrollbar" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: tableRenderKey.value,
            ref_key: "tableRef",
            ref: tableRef,
            data: menuTree.value,
            "row-key": "Id",
            border: "",
            "default-expand-all": "",
            indent: 20,
            lazy: "",
            load: load,
            "tree-props": { children: 'Children', hasChildren: 'hasChildren' },
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "Name",
                label: "菜单名称",
                "min-width": "200"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_5, [
                    (row.IconNew)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          class: "cell-icon"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(row.IconNew))))
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(row.Name), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "menuType",
                label: "菜单类型",
                width: "100",
                align: "center",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tag, {
                    type: getMenuTypeType(row)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getMenuTypeText(row)), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Code",
                label: "路由",
                "min-width": "180"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(row.Code || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "OrderSort",
                label: "排序",
                width: "90",
                align: "center",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(row.OrderSort), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Enabled",
                label: "是否禁用",
                width: "100",
                align: "center",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tag, {
                    type: row.Enabled ? 'success' : 'danger',
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.Enabled ? '启用' : '禁用'), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "IsHide",
                label: "是否隐藏",
                width: "100",
                align: "center",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_tag, {
                    type: row.IsHide ? 'info' : 'success',
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.IsHide ? '隐藏' : '显示'), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              (_unref(canAny)('新增', '编辑', '删除'))
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "操作",
                    width: "200",
                    fixed: "right",
                    align: "center",
                    "header-align": "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      (_unref(can)('新增'))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            icon: _unref(Plus),
                            link: "",
                            size: "small",
                            onClick: ($event: any) => (handleAddChild(row))
                          }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode(" 添加 ")
                            ])),
                            _: 2
                          }, 1032, ["icon", "onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(can)('编辑'))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "warning",
                            icon: _unref(Edit),
                            link: "",
                            size: "small",
                            onClick: ($event: any) => (handleEdit(row))
                          }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode(" 编辑 ")
                            ])),
                            _: 2
                          }, 1032, ["icon", "onClick"]))
                        : _createCommentVNode("", true),
                      (_unref(can)('删除'))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            type: "danger",
                            icon: _unref(Delete),
                            link: "",
                            size: "small",
                            onClick: ($event: any) => (handleDelete(row))
                          }, {
                            default: _withCtx(() => _cache[18] || (_cache[18] = [
                              _createTextVNode(" 删除 ")
                            ])),
                            _: 2
                          }, 1032, ["icon", "onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogTitle.value,
      width: "600px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        (_unref(can)('保存'))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: saving.value,
              onClick: handleSubmit
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("确定")
              ])),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          rules: formRules.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "菜单类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: menuType.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuType).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "目录" }),
                    _createVNode(_component_el_radio_button, { label: "页面" }),
                    _createVNode(_component_el_radio_button, { label: "按钮" })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: menuType.value === '按钮' ? '按钮名称' : '菜单名称',
              prop: "Name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.Name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.Name) = $event)),
                  placeholder: menuType.value === '按钮' ? '请输入按钮名称' : '请输入菜单名称'
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: "菜单路由",
              prop: "Code",
              rules: codeRules.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.Code,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.Code) = $event)),
                  placeholder: "请输入页面组件路径，如：/ParameterSettings/BusinessScope/index.vue",
                  disabled: isCodeDisabled.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_el_form_item, { label: "图标" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.IconNew,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.IconNew) = $event)),
                  placeholder: "请选择图标",
                  clearable: "",
                  filterable: "",
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconOptions.value, (component, name) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: name,
                        label: name,
                        value: name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(component)))
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, _toDisplayString(name), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: formData.OrderSort,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.OrderSort) = $event)),
                  min: -100,
                  max: 100
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (menuType.value !== '按钮')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "是否按钮"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: formData.IsButton,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.IsButton) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: formData.Enabled,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.Enabled) = $event)),
                  "active-text": "激活",
                  "inactive-text": "禁用"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "是否隐藏" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: formData.IsHide,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.IsHide) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "接口选择" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.Mid,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.Mid) = $event)),
                  placeholder: "请选择接口",
                  clearable: "",
                  filterable: "",
                  class: "w-full",
                  onVisibleChange: handleInterfaceSelectVisibleChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(interfaceList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.Id,
                        label: item.Name,
                        value: item.Id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(item.Name), 1),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.LinkUrl), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "是否缓存" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: formData.IskeepAlive,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.IskeepAlive) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.Description,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.Description) = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入描述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})